import SelectSolutions from './SelectSolutions';

export default SelectSolutions;
